import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { useContext } from "react"; // import PropTypes from "prop-types";

import classnames from "classnames";
import { withRouter } from "react-router-dom"; // Components

import Icon from "../Icon";
import { RouterHistoryContext } from "./RouterHistory";
import "./BackButton.scss";
export var BackButton = function BackButton(a) {
  var b = a.type,
      c = a.children,
      d = a.className,
      e = a.title,
      f = a.to,
      g = a.defaultTo,
      h = a.history,
      i = a.external,
      j = a.unless,
      k = _objectWithoutProperties(a, ["type", "children", "className", "title", "to", "defaultTo", "history", "external", "unless"]);

  b || (b = "button"), d = classnames(d, "backbutton");
  var l = useContext(RouterHistoryContext),
      m = l.old,
      n = {},
      o = f || m && m.path || g,
      p = m && m.path && m.path.split("/") || [];
  j = j && j.split("/")[1], n = j && p[1] && j === p[1] ? _objectSpread({}, n, {}, m, {
    path: j
  }) : _objectSpread({}, n, {
    name: f ? e : m && m.name || e,
    path: o
  });
  var q = n.name;
  return /*#__PURE__*/React.createElement(b, {
    tag: b,
    className: d,
    onClick: function goBack() {
      var a = "/" === n.path[0] ? n.path : "/".concat(n.path);
      return i ? window.location = a : h.push(a);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow"
  }), q ? "back to ".concat(q) : "back");
}; // BackButton.propTypes = {};

export default withRouter(BackButton);